import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
//import { useNavigate } from "react-router";
import { selectIsEligible } from 'selectors/partnerStatusSelector';
import { Features } from 'reducers/partnerStatusReducer';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';
import { cardStyle } from 'views/OrderNewProductOrService/OrderNewProductOrService';
import CardBodyComponent from '../common/card/CardBodyComponent';
import CardHeaderComponent from '../common/card/CardHeaderComponent';
import CardTooltipButton from '../common/card/CardTooltipButton';
import { RootState } from 'store';

interface ViewMandateProposalProps {
  partnerId?: string;
  brUid?: string;
}

const ViewMandateProposal = ({ partnerId }: ViewMandateProposalProps) => {
  const isEligibleForDMStore = useSelector(selectIsEligible) as
    | (FeatureEligibility[] & { message?: string; messages?: string[] })
    | undefined;

  const MSD_URL = useSelector((state: RootState) => state.appConfig.MSD_URL);

  const handleDiscretionaryMandateClick = () => {
    if (partnerId) {
      window?.open(`${MSD_URL}/#/msd/offerings?show-for-prospect=${partnerId}`, '_blank')?.focus();
    }
  };

  const isEligibleForDM = useMemo<FeatureEligibility | undefined>(() => {
    if (isEligibleForDMStore?.message) return undefined;
    return (
      isEligibleForDMStore?.find((eligibility) => eligibility.feature === Features.VIEW_MANDATE_PROPOSAL) ?? undefined
    );
  }, [isEligibleForDMStore]);

  const title = useMemo<React.ReactNode>(() => {
    if (isEligibleForDMStore?.messages) {
      const messages = isEligibleForDMStore.messages;
      return (
        <>
          <div>{partnerId ? 'Partner' : 'Business relation '} is missing following data:</div>
          {messages.map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </>
      );
    }
    return `${partnerId ? 'Partner' : 'Business relation'}  not eligible to View a Mandate Proposal.`;
  }, [isEligibleForDMStore, partnerId]);

  return (
    <Grid data-testid="view-mandate-proposal" item sx={cardStyle}>
      <CardHeaderComponent title={'View mandate proposal'} />
      <CardBodyComponent
        content={'View existing proposals for an investment mandate in the Mandate Solution Designer (MSD).'}
      />
      <CardTooltipButton
        id={'discretionary-mandate-button'}
        data-testid={'discretionary-mandate-button'}
        buttonText={'Open MSD'}
        isEligible={isEligibleForDM?.isEligible ?? false}
        handleClick={handleDiscretionaryMandateClick}
        tooltipTitle={title}
      />
    </Grid>
  );
};

export default ViewMandateProposal;
